export const questionTranslations = {
    clientNumber: {
        label: 'Número de cliente',
        description: 'ID de clientes en Portfol',
        invalidMessages: {
            format: 'Ingrese un número de 1 a 3 dígitos de largo.'
        }
    },
    businessName: {
        label: 'Nombre del negocio',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        tooltip: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
    },
    dba: {
        label: 'DBA',
        description: 'Haciendo negocios como',
        tooltip: ''
    },
    race: {
        label: 'Raza'
    },
    clientRelationshipManager: {
        label: 'Gerente de relaciones con el cliente'
    },
    nonProfit: {
        label: 'Sin fines de lucro?'
    },
    monthFiscalYearEnds: {
        label: 'Mes en que termina el año fiscal'
    },
    daysAfterFiscalYearEnd: {
        label: 'Días después del final del año fiscal en que se debe presentar el informe'
    },
    businessType: {
        label: 'Tipo de negocio'
    },
    yearEstablished: {
        label: 'Fecha de establecimiento'
    },
    ein: {
        label: 'EIN',
        invalidMessages: {
            format: 'Formato inválido. EIN debe tener 9 dígitos de longitud.'
        }
    },
    orgForm: {
        label: 'Forma de organización'
    },
    activeLoan: {
        label: '¿El préstamo está activo en nuestros registros?'
    },
    inDefault: {
        label: '¿Por incumplimiento?'
    },
    doNotContact: {
        label: 'No contactar'
    },
    okToContact: {
        label: 'Se puede contactar?'
    },
    okToContactOrg: {
        label: 'Se puede contactar?'
    },
    loanNumber: {
        label: 'Número de préstamo',
        description: 'El formato correcto debe ser de 5 a 8 dígitos y debe incluir 2 guiones (por ejemplo, 12-34-56)',
        invalidMessages: {
            format: 'Formato de número de préstamo no válido.'
        }
    },
    portfolContactId: {
        label: 'ID de contacto de Portfol'
    },
    loanAmount: {
        label: 'Monto de préstamo aprobado'
    },
    loanBalance: {
        label: 'Saldo actual del préstamo'
    },
    actualSettlementDate: {
        label: 'Fecha real de liquidación'
    },
    effectiveTerminationDate: {
        label: 'Fecha de terminación efectiva'
    },
    groupFinancingTotal: {
        label: 'Total de financiamiento grupal'
    },
    closed: {
        label: '¿Cerrado?'
    },
    loanOfficer: {
        label: 'Gestor de préstamos'
    },
    percentOwnership: {
        label: 'Porcentaje de propiedad',
        checkbox: {
            label: '¿Es propietario?'
        }
    },
    suffix: {
        label: 'Sufijo',
        placeholder: 'Por ejemplo, Junior (Jr), Senior (Sr)'
    },
    honorific: {
        label: 'Honorífico',
        placeholder: 'Por ejemplo, Doctor (Dr), Profesor (Prof)'
    },
    pronouns: {
        label: 'Pronombres',
        placeholder: 'Por ejemplo, Elle, ella, él',
        tooltip:
            'Si sus pronombres no están en la lista, solo escríbalos en el campo a continuación y haga clic en el botón `+ Crear` que aparece.'
    },
    salutation: {
        label: 'Saludo para la carta'
    },
    contactsModule: {
        label: 'Contactos'
    },
    firstName: {
        label: 'Primer nombre'
    },
    middleInitial: {
        label: 'Inicial del segundo nombre'
    },
    lastName: {
        label: 'Apellido'
    },
    jobTitle: {
        label: 'Título de empleo'
    },
    primaryContact: {
        label: 'Contacto principal',
        nothingFound: 'No se pudo encontrar un contacto con ese nombre',
        description:
            'La persona asignada como contacto principal de su organización funcionará como el administrador principal del perfil de su organización en esta plataforma.'
    },
    orgStatus: {
        label: 'Estado'
    },
    childOrgs: {
        label: 'Organizaciones filiales '
    },
    loanCorp: {
        label: 'Compañía de préstamos'
    },
    loanPartner: {
        label: 'Socio del préstamo'
    },
    loanPartnerShare: {
        label: 'Parte del socio del préstamo',
        placeholder: ' %'
    },
    fromChildOrg: {
        label: 'De la organizacion filial',
        description: 'El Número de cliente (ID de Portfol) de la organizacion filial de la que se hereda este préstamo'
    },
    financialContact: {
        label: 'Contacto financiero',
        nothingFound: 'No se pudo encontrar un contacto con ese nombre',
        description:
            'La persona asignada como contacto financiero también recibirá acceso a esta plataforma y se incluirá en toda la correspondencia sobre las próximas encuestas de datos financieros.',
        tooltip: 'En algunos casos, esta puede ser la misma persona que el contacto principal.'
    },
    email: {
        label: 'Correo electrónico ',
        invalidMessages: {
            format: 'El correo electrónico no es válido.'
        }
    },
    secondaryEmail: {
        label: 'Correo electrónico secundario',
        invalidMessages: {
            format: 'El correo electrónico no es válido.'
        }
    },
    phone: {
        label: 'Teléfono',
        invalidMessages: {
            format: 'EL número de teléfono no es válido.',
            extWithoutNum: 'La extensión proporcionada no tiene número de teléfono.'
        }
    },
    homePhone: {
        label: 'Teléfono de casa',
        invalidMessages: {
            format: 'EL número de teléfono no es válido.'
        }
    },
    mobilePhone: {
        label: 'Teléfono móvil',
        invalidMessages: {
            format: 'EL número de teléfono no es válido.'
        }
    },
    orgName: {
        label: 'Nombre de la organización'
    },
    gender: {
        label: 'Género'
    },
    raceEthnicity: {
        label: 'Raza / Origen étnico',
        description: 'Seleccione todo lo que corresponda'
    },
    veteran: {
        label: '¿Veterano?'
    },
    disabled: {
        label: '¿Discapacitado?'
    },
    owner: {
        label: '¿Es propietario?'
    },
    businessLegalStructure: {
        label: '¿Cómo está estructurada legalmente su empresa?'
    },
    operationStartDate: {
        label: '¿Cuándo comenzó a operar su negocio?'
    },
    businessDetail: {
        label: 'Describa su negocio a detalle.'
    },
    stillRunning: {
        label: '¿Todavía está dirigiendo su negocio?'
    },
    businessCloseDate: {
        label: 'Si no, ¿cuándo cerró su negocio?'
    },
    businessCloseReason: {
        label: 'Si no, ¿por qué cerró su negocio?'
    },
    businessCloseReasonDescription: {
        label: 'Si seleccionó "otro", por favor incluya una descripción.'
    },
    lastDayFiscalYeah: {
        label: '¿Cuál es el último día de su año fiscal?'
    },
    ownerCount: {
        label: 'Indique a continuación los propietarios, incluido usted, de su organización.',
        description:
            'Consideramos propietarios a cualquier persona con al menos una participación del 20%. Si la estructura comercial de su empresa no tiene propietarios, en su lugar, responda para su equipo de liderazgo ejecutivo.'
    },
    executiveCount: {
        label: 'Indique a continuación los miembros del equipo ejecutivo, incluido usted, de su organización.'
    },
    goalForLoan: {
        label: 'Cuando solicitó financiación con CIC, ¿cuál de los siguientes describe mejor el objetivo que tenía en mente?'
    },
    whichFinancialProblem: {
        label: '¿Qué tipo de problema financiero urgente o futuro necesita (o necesitaba) resolver?'
    },
    describeFinancialProblem: {
        label: 'Si seleccionó "otro" o un "problema no financiero", describa.'
    },
    previousLoanApplication: {
        label: 'Antes de solicitar un préstamo/crédito con CIC, ¿había solicitado un préstamo/crédito en otro lugar?'
    },
    wereExpectationsMet: {
        label: 'En general, qué tan bien se cumplieron sus expectativas con sus experiencias de préstamo/crédito <highlight><i>en otros lugares</i></highlight>?'
    },
    experienceCompare: {
        label: '¿Cómo compararía su experiencia solicitando un préstamo/crédito <highlight><i>con CIC</i></highlight> con sus otras experiencias?',
        description: 'Mi experiencia con CIC fue...'
    },
    experienceCompareDescription: {
        label: '¿Le gustaría elaborar más sobre su respuesta anterior?'
    },
    reasonForLoanApproval: {
        label: '¿Cuáles son algunos de los puntos fuertes que cree que le ayudaron a obtener su préstamo/crédito CIC?',
        description: 'Seleccione todo lo que corresponda.'
    },
    extentOfGoalsAccomplished: {
        label: 'Cuando solicitó su préstamo/crédito con CIC, la razón principal que puso fue _________. ¿Hasta qué punto logró este objetivo?'
    },
    accomplishedOtherGoals: {
        label: '¿Su préstamo/crédito con CIC ayudó a lograr algún otro objetivo?'
    },
    otherGoalsAccomplished: {
        label: 'Si es así, ¿qué otro(s) objetivo(s) logró con su préstamo/crédito de CIC?'
    },
    extentGoalsAccomplishedByLoan: {
        label: 'En general, ¿hasta qué grado su préstamo/crédito con CIC le ayudó a alcanzar su(s) objetivo(s)?'
    },
    revenueSatisfaction: {
        label: 'Cuando recibió su préstamo/crédito de CIC, sus ingresos brutos anuales eran _______. ¿Qué tan satisfecho está con los cambios en los ingresos desde ese momento?'
    },
    expectationMet: {
        label: 'En general, ¿CIC ha estado a la altura de sus expectativas?'
    },
    suggestionsForCIC: {
        label: '¿Qué podría hacer CIC, si acaso, para cumplir mejor con sus expectativas?'
    },
    challengesDescription: {
        label: 'Además de financiamiento, ¿hay desafíos que enfrenta como propietario de negocio con los que podría usar ayuda en este momento? Si es así, explique.'
    },
    likelyOtherCapitalSource: {
        label: 'Si necesitara capital adicional (préstamo, crédito, etc.) en el futuro, ¿Dónde es más probable que vaya?'
    },
    grossSalesIncome: {
        label: '¿Cuáles fueron las ventas/ingresos brutos anuales del negocio entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?',
        description: 'Si su negocio no estaba operando durante este periodo, ingrese $0'
    },
    businessPerformance: {
        label: '¿Cómo le fue financieramente a su negocio entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?'
    },
    businessPerformanceMeetExpectations: {
        label: '¿Cómo cumplió el desempeño financiero de su empresa entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}} con sus expectativas?'
    },
    pleaseExplainPreviousAnswer: {
        label: 'Elabore su respuesta anterior. ¿Qué expectativas financieras específicas tenía y de qué manera(s) las cumplió o no su negocio?'
    },
    employeeCount: {
        label: 'Sin contar a usted mismo y sin contar a los contratistas, ¿cuántos empleados remunerados tenía su empresa al final de {{it.targetPeriod.end}}?',
        description: 'Los empleados se definen como aquellos que reciben un formulario de impuestos W-2 de la empresa.',
        placeholder: 'Número de empleados'
    },
    offeredHealthInsuranceCount: {
        label: '¿A cuántos se les ofreció seguro médico entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?',
        // label: 'De esos {{it.employeeCount}} empleados, ¿a cuántos se les ofreció un seguro médico entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?'
        placeholder: 'Número de empleados'
    },
    offeredPtoCount: {
        label: '¿A cuántos se les ofreció horas de vacaciones pagadas entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?',
        // label: 'De esos {{it.employeeCount}} empleados, ¿a cuántos se les ofreció horas de vacaciones pagadas entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?'
        placeholder: 'Número de empleados'
    },
    offeredRetirementPlanCount: {
        label: '¿A cuántos se les ofreció un plan de jubilación entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?',
        // label: 'De esos {{it.employeeCount}} empleados, ¿a cuántos se les ofreció un plan de jubilación entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?'
        placeholder: 'Número de empleados'
    },
    offeredRaiseCount: {
        label: '¿A cuántos se les ofreció un aumento de sueldo entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?',
        // label: 'De esos empleados, ¿a cuántos se les ofreció un aumento durante el periodo de tiempo X?'
        placeholder: 'Número de empleados'
    },
    classifyEmployeeWages: {
        label: 'Al observar los salarios, ¿cómo clasificaría a sus empleados al {{it.targetPeriod.end}}?',
        description:
            'Expanda cada nivel salarial a continuación para los que tiene empleados cuyo salario está dentro de los límites descritos. Ingrese el número total de empleados de ese nivel, así como el número de tiempo completo/parcial.'
    },
    fullTimeEmployeeCount: {
        label: 'De esos {{it.employeeCount}} empleados, ¿cuántos trabajan tiempo completo?'
    },
    partTimeEmployeeCount: {
        label: 'De esos {{it.employeeCount}} empleados, ¿cuántos trabajan medio tiempo?'
    },
    wereContractorsHired: {
        label: '¿Tuvo algún contratista para su negocio entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?'
    },
    contractorsWithHourlyRateCount: {
        label: 'De esos contratistas, ¿cuántos se pagaban por hora?'
    },
    contractorsPaidPerJobCount: {
        label: 'De esos contratistas, ¿cuántos se pagaban individualmente por trabajo?'
    },
    classifyContractorsPay: {
        label: 'Al observar el pago por hora, ¿cómo clasificaría a sus contratistas al {{it.targetPeriod.end}}?'
    },
    employeesFullPartTime: {
        label: 'De esos empleados, ¿cuántos trabajan tiempo completo/medio tiempo?',
        description: 'Se define tiempo completo como 32 horas/semana o más.'
    },
    contractorsFullPartTime: {
        label: 'De esos contratistas, ¿cuántos trabajan tiempo completo/medio tiempo?'
    },
    personalPay: {
        label: '¿Cuánto de ingreso o salario ("sueldo para llevar a casa") se pagó a usted mismo del negocio entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?'
    },
    personalWeeklyHours: {
        label: 'En una semana promedio, ¿cuántas horas trabajó usted típicamente en el negocio entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?',
        placeholder: 'Número de horas'
    },
    personalMonthsWorkedPerYear: {
        label: '¿Cuántos meses del año trabajó en su negocio entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?',
        placeholder: 'Número de meses'
    },
    personalPayMeetExpectations: {
        label: '¿A qué medida diría que la cantidad que se pagó del negocio cumplió con sus expectativas?'
    },
    reasonExpectationsNotMet: {
        label: '¿Cuál es la razón principal por la que siente que no se cumplieron sus expectativas?'
    },
    expectationNotMetDescription: {
        label: 'Si seleccionó "otro", por favor incluya una descripción.'
    },
    primaryOrSupplementalSourceOfIncome: {
        label: '¿Cómo contribuyó su negocio al ingreso total del hogar desde {{it.targetPeriod.start}} hasta {{it.targetPeriod.end}}?'
    },
    sharedIncomeOrExpensesCount: {
        label: 'Contándose a usted mismo, a su cónyuge/pareja y a sus hijos, ¿cuántas personas vivieron con usted y compartieron ingresos o gastos entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?',
        description:
            'No incluya roomates o inquilinos que no compartan ingresos o gastos, pero sí incluya a miembros de la familia extendida o parejas significativas si comparten ingresos y gastos. Si esto cambió durante el año, indique el número que duró durante el periodo de tiempo más largo.',
        invalidMessages: {
            numberTooHigh: 'El valor no puede exceder 25.'
        }
    },
    publicAssistanceReceived: {
        label: 'Entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}, ¿Usted recibió asistencia pública (por ejemplo, TANF, SNAP, Sección 8, Medicaid (AHCCCS), etc.)',
        description:
            'Definimos "Asistencia pública" como servicios disponibles para personas cuyos ingresos están por debajo de cierto umbral. No considere beneficios que NO se determinan según los niveles de ingresos, como FEMA, Medicare, etc.'
    },
    totalHouseholdIncome: {
        label: '¿Cuál fue el ingreso total de su hogar desde {{it.targetPeriod.start}} hasta {{it.targetPeriod.end}} (incluidos los ingresos del negocio y de otros trabajos)?'
    },
    householdIncomeComparison: {
        label: 'Compare el ingreso total de su hogar con el año anterior. El ingreso de su hogar desde {{it.targetPeriod.start}} hasta {{it.targetPeriod.end}} fue...'
    },
    ableToSaveMoney: {
        label: '¿Pudo ahorrar dinero entre {{it.targetPeriod.start}} y {{it.targetPeriod.end}}?'
    },
    costOfGoods: {
        label: 'Costo de las mercancías'
    },
    ownerName: {
        label: '¿Cuál es el nombre del Propietario/Miembro del equipo ejecutivo #1?'
    },
    ownerRace: {
        label: '¿Cuál es la raza/origen étnico del Propietario #1?'
    },
    ownerGender: {
        label: '¿Cuál es el género del Propietario #1?'
    },
    ownerVeteran: {
        label: '¿El Propietario #1 es veterano?'
    },
    ownerDisability: {
        label: '¿El Propietario #1 tiene alguna discapacidad?'
    },
    costTable: {
        invalidMessages: {
            totalTooLow: 'El monto total no puede ser menor que la suma de los montos enumerados.'
        }
    },
    employeeCountWageTier: {
        label: '¿Cuántos empleados en este rango salarial?'
    },
    contractorCountWageTier: {
        label: '¿Cuántos contratistas en este rango salarial?'
    },
    employeeCountWageTier0: {
        label: '¿Cuántos empleados ganan menos de $13.85/hr?'
    },
    employeeCountWageTier1: {
        label: '¿Cuántos empleados ganan $13.85 - $17.99/hr (~$28,808 - $37,439, anualmente)?'
    },
    employeeCountWageTier2: {
        label: '¿Cuántos empleados ganan $18.00 - $21.99/hr (~$37,440 - $45,759, anualmente)?'
    },
    employeeCountWageTier3: {
        label: '¿Cuántos empleados ganan $22.00 - $25.99/hr (~$45,760 - $54,079, anualmente)?'
    },
    employeeCountWageTier4: {
        label: '¿Cuántos empleados ganan $26.00 - $32.99/hr (~$54,080 - $68,639, anualmente)?'
    },
    employeeCountWageTier5: {
        label: '¿Cuántos empleados ganan $33.00 - $47.99/hr (~$68,640 - $99,839, anualmente)?'
    },
    employeeCountWageTier6: {
        label: '¿Cuántos empleados ganan $48.00/hr (~$99,840, anualmente) o más?'
    },
    employeeCountWageTierUnder: {
        label: '¿Cuántos empleados ganan menos de <strong>{{hourly}}</strong>/hr?'
    },
    employeeCountWageTierOver: {
        label: '¿Cuántos empleados ganan <strong>{{hourly}}/hr</strong> (<strong>~{{annual}}</strong>, anualmente) o más?'
    },
    employeeCountWageTierBetween: {
        label: '¿Cuántos empleados ganan <strong>{{hourlyLow}}</strong> - <strong>{{hourlyHigh}}</strong>/hr (~<strong>{{annuallyLow}}</strong> - <strong>{{annuallyHigh}}</strong>, anualmente)?'
    },
    tierSectionUnder: {
        label: 'Menos de {{hourly}}/hr'
    },
    tierSectionOver: {
        label: '{{hourly}}/hr (~{{annual}}, anualmente) o más'
    },
    tierSectionOverHourOnly: {
        label: '{{hourly}}/hr o más'
    },
    tierSectionBetween: {
        label: '{{hourlyLow}} - {{hourlyHigh}}/hr (~{{annuallyLow}} - {{annuallyHigh}}, anualmente)'
    },
    tierSectionBetweenHourOnly: {
        label: '{{hourlyLow}} - {{hourlyHigh}}/hr'
    },
    wageRanger: {
        invalidMessages: {
            sumTotal:
                'La suma de los que están en los rangos salariales no es igual al número total de trabajadores indicados.',
            wageTierSum: 'La suma de tiempo completo y medio tiempo no es igual al total.'
        }
    },
    common: {
        description: {
            backendCalculation: 'Este valor no se puede editar manualmente.'
        },
        invalidMessages: {
            exceedsEmployeeCount: 'La cantidad no puede ser mayor que el número total de empleados',
            monthTooHigh: 'El valor no puede ser mayor que 12',
            hoursInWeekTooHigh: 'El valor no puede ser mayor que 168',
            numberTooLow: 'El valor no puede ser menor que 0',
            invalidNumber: 'Ingrese un número válido'
        }
    },
    isEnrolled: {
        label: 'Matriculado'
    },
    userRole: {
        label: 'Rol'
    },
    profitLoss: {
        label: 'Estado de ganancias y pérdidas'
    },
    profitLossIncomeTable: {
        label: 'Ingresos'
    },
    profitLossExpensesTable: {
        label: 'Gastos'
    },
    profitLossGrossReceipt: {
        label: 'Entradas brutas o ventas'
    },
    profitLossReturns: {
        label: 'Devoluciones y descuentos'
    },
    profitLossCostOfGoods: {
        label: 'Costo de mercancías vendidas'
    },
    profitLossGrossProfit: {
        label: 'Ganancias brutas'
    },
    profitLossOtherIncome: {
        label: 'Otros ingresos'
    },
    profitLossGrossIncome: {
        label: 'Ingreso bruto'
    },

    profitLossExpensesAdvertising: {
        label: 'Publicidad'
    },
    profitLossExpensesAuto: {
        label: 'Auto'
    },
    profitLossExpensesContractLabor: {
        label: 'Mano de obra contratada'
    },
    profitLossExpensesDepreciation: {
        label: 'Depreciación'
    },
    profitLossExpensesInterest: {
        label: 'Interés'
    },
    profitLossExpensesInsurance: {
        label: 'Seguro'
    },
    profitLossExpensesLegal: {
        label: 'Servicios legales y profesionales'
    },
    profitLossExpensesOffice: {
        label: 'Gastos de oficina'
    },
    profitLossExpensesRent: {
        label: 'Alquiler o arrendamiento'
    },
    profitLossExpensesRepairs: {
        label: 'Rreparación y mantenimiento'
    },
    profitLossExpensesSupplies: {
        label: 'Suministros'
    },
    profitLossExpensesTax: {
        label: 'Impuestos'
    },
    profitLossExpensesTravel: {
        label: 'Viajes'
    },
    profitLossExpensesMeals: {
        label: 'Comida'
    },
    profitLossExpensesUtilities: {
        label: 'Servicios públicos'
    },
    profitLossExpensesWages: {
        label: 'Salarios'
    },
    profitLossExpensesOther: {
        label: 'Otros gastos'
    },
    profitLossExpensesTotal: {
        label: 'Gastos totales'
    },
    profitLossNetProfit: {
        label: 'Ganancia neta (or pérdida neta)',
        tooltip: 'Ingreso bruto menos gastos totales'
    },
    profitLossNetProfitTable: {
        label: ''
    },
    balanceSheetTableEquityTable: {
        label: ''
    },
    balanceSheetAssets: {
        label: 'Activos',
        description:
            'Por favor, indique el valor de los activos de su empresa en el último día de {{it.targetPeriod.end}}. Los activos incluyen saldos en efectivo en cuentas bancarias y de inversión, cuentas por cobrar (dinero que se le debe), inventario, mobiliario, vehículos, equipos, edificios, terrenos y cualquier otra propiedad de su empresa.'
    },
    balanceSheetLiabilities: {
        label: 'Obligaciones',
        description:
            'Indique el valor total las obligaciones de su empresa, o las cantidades que debe a otros, en el último día de {{it.targetPeriod.end}}. En las obligaciones se incluyen las cuentas por pagar ( cantidades adeudadas a proveedores o vendedores), los pagos anticipados de clientes, los préstamos a corto y largo plazo, los saldos de tarjetas de crédito, los impuestos por pagar y cualquier otra obligación financiera de la que sea responsable su empresa.'
    },
    balanceSheetEquity: {
        label: 'Patrimonio Neto'
    },
    balanceSheetTable: {
        label: 'Hoja de Balance'
    },
    financialsEmployeeCount: {
        label: 'Número de empleados en el último día de {{it.targetPeriod.end}}',
        description:
            'Número Total de Empleados: Incluye a todas las personas empleadas, de cualquier horario de trabajo.'
    },
    financialsEmployeeFullTime: {
        label: 'Equivalentes a tiempo completo',
        description:
            'Un trabajador a tiempo completo trabaja 40 horas semanales. Si emplea a personas a tiempo parcial, traduzca sus horas a equivalentes a tiempo completo (ETC) (es decir, si dos empleados a tiempo parcial trabajan 30 horas semanales cada uno, el equivalente a tiempo completo es 1.5. 60 horas totales divididas por 40 horas = 1.5 ETC)'
    }
};
